import { render } from "./login.vue?vue&type=template&id=58522525&scoped=true&bindings={\"type\":\"data\",\"email\":\"data\",\"password\":\"data\",\"name\":\"data\",\"company\":\"data\",\"instagram\":\"data\",\"login\":\"options\",\"live\":\"options\"}"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=58522525&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58522525"

export default script